<div class="field-group"
     [class.origami-updated]="isUpdatedByOrigami"
>
  <p-iftalabel class="w-full">
    @if (control(); as ctrl) {
      <p-select class="w-full"
                filterBy="label"
                optionLabel="label"
                optionValue="value"
                [editable]="editable()"
                [filter]="true"
                [formControl]="ctrl"
                [id]="inputId()"
                [invalid]="showInvalidState"
                [options]="currencyOptions()"
                [placeholder]="placeholder()"
      />
    }
    <label class="block font-medium mb-1"
           [for]="inputId()"
    >
      {{ label() }}
    </label>
  </p-iftalabel>
  @if (showRequiredHint) {
    <small class="block text-red-500 text-xs mt-1">{{ label() }} is required.</small>
  }
</div>
